export enum CalendarViewEnum {
  week = 'week',
  month = 'month',
  year = 'year',
}
